export default function ChevronLeftIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.6875 10.0068C4.6875 9.86296 4.7124 9.73014 4.76221 9.6084C4.81755 9.48665 4.90055 9.37044 5.01123 9.25977L11.4775 2.93457C11.6657 2.75195 11.8926 2.66064 12.1582 2.66064C12.3408 2.66064 12.5041 2.70492 12.6479 2.79346C12.7974 2.87646 12.9163 2.98991 13.0049 3.13379C13.0934 3.27767 13.1377 3.44092 13.1377 3.62354C13.1377 3.88363 13.0353 4.11605 12.8306 4.3208L7.00342 10.0068L12.8306 15.6929C13.0353 15.8976 13.1377 16.1328 13.1377 16.3984C13.1377 16.5755 13.0934 16.736 13.0049 16.8799C12.9163 17.0293 12.7974 17.1455 12.6479 17.2285C12.5041 17.3171 12.3408 17.3613 12.1582 17.3613C11.8926 17.3613 11.6657 17.2673 11.4775 17.0791L5.01123 10.7539C4.90055 10.6432 4.81755 10.527 4.76221 10.4053C4.7124 10.2835 4.6875 10.1507 4.6875 10.0068Z" />
    </svg>
  );
}
